import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LegacySquirrelUserDto, Sq3IdPairDto, UserListMigrationResponse } from '../models/LegacySquirrelUser';
import { CreateProjectRequest } from '../models/legacy_squirrel/CreateProjectRequest';
import { MigratedLegacyProjectDto, LegacyProjectToMigrateDto } from '../models/LegacyProjectToMigrateDto';
import { SquirrelSessionRequest, SquirrelSessionResponse } from '../models/SquirrelSession';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({providedIn: 'root'})
export class LegacySquirrelService  extends BaseService {
  
  
  

  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService) {
    super();
  }

  getLegacySquirrelProjects1(selectedEnvironment: string) : Observable<LegacyProjectToMigrateDto[]>  {
    return this.httpClient.get<LegacyProjectToMigrateDto[]>(`${selectedEnvironment}squirrelAPI/SquirrelV3/GetProjectsForMigration`);
  }

  // Users
  getLegacySquirrelUsers(selectedEnvironment: string) : Observable<UserListMigrationResponse> {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserListMigrationResponse>(`${selectedEnvironment}squirrelAPI/SquirrelV3/GetUsersForMigration`, {headers: headers});
  }  

  postMigratedUserInfo(sq3IdPairs: Sq3IdPairDto[], selectedEnvironment: string) : Observable<Sq3IdPairDto[]> {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<Sq3IdPairDto[]>(`${selectedEnvironment}squirrelAPI/SquirrelV3/ConfirmUsersMigrationDone`, sq3IdPairs, {headers: headers});
  }


  // Projects
  getLegacySquirrelProjects(selectedEnvironment: string) : Observable<LegacyProjectToMigrateDto[]> {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<LegacyProjectToMigrateDto[]>(`${selectedEnvironment}squirrelAPI/SquirrelV3/GetProjectsForMigration`, {headers: headers});
  }

  postMigratedProjectInfo(legacyProjectMigratedTo : MigratedLegacyProjectDto[], selectedEnvironment: string) : Observable<MigratedLegacyProjectDto[]> {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<MigratedLegacyProjectDto[]>(`${selectedEnvironment}squirrelAPI/SquirrelV3/ConfirmProjectsMigrationDone`, legacyProjectMigratedTo, {headers: headers});
  }


  // --------------------------------------------
 
  testConnection():Observable<any>{
    return this.httpClient.get<any>(`${this.localLegacySquirrelCommonApi}`);
  }

  getPartModels() : Observable<any> {
    return this.httpClient.post<any>(`${this.localLegacySquirrelCommonApi}`,  {});
  }

  createPartModel() : Observable<any>{
    return this.httpClient.post<any>(`${this.localLegacySquirrelCommonApi}`, {});
  }

  disablePartModel() : Observable<any> {
    return this.httpClient.post<any>(`${this.localLegacySquirrelCommonApi}`, {});
  }

  deletePartModel() : Observable<any> {
    return this.httpClient.delete<any>(`${this.localLegacySquirrelCommonApi}`);
  }

  getModelData() : Observable<any> {
    return this.httpClient.get<any>(`${this.localLegacySquirrelCommonApi}`);
  }

  getModelRevData() : Observable<any> {
    return this.httpClient.get<any>(`${this.localLegacySquirrelCommonApi}`);
  }
  
  createProject(project: CreateProjectRequest) : Observable<CreateProjectRequest> {
    return this.httpClient.post<CreateProjectRequest>(`${this.localLegacySquirrelV3}/CreateProject`, project);
  }

  createProjectSession(squirrelSessionRequest: SquirrelSessionRequest) :Observable<SquirrelSessionResponse> {

    // return this.httpClient.post<SquirrelSessionResponse>(`${this.localLegacySquirrelV3}/StartSession`, squirrelSession);

    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<SquirrelSessionResponse>(`${squirrelSessionRequest.projectUrl}squirrelAPI/SquirrelV3/StartSession`, squirrelSessionRequest, { headers: headers });
  }  
}
